import { EMemberChoicesLabels } from 'affiny-core/modules/api/models/memberchoice/memberchoice.types';
import { IAnswer } from 'affiny-core/modules/api/models/reflist/reflist.types';
import { getAnswerFromLabel } from 'affiny-core/modules/helpers/informationList';
import {
  TAnswers,
  TAnswersLabels,
} from 'affiny-core/modules/memberchoices/types';

interface IGroup {
  label: EMemberChoicesLabels;
  modifier?: (answer: IAnswer) => string;
}

const KEEP_IT_FOR_ME_ANSWER_ID = 0;

const mapAnswersGroup = (memberAnswers: TAnswers, group: IGroup[]) => {
  const mappedGroup = group.map(({ label, modifier }) => ({
    ...memberAnswers[label][0], // Information answers are never multiples so we take the first
    modifier,
  }));
  const groupWithoutPrivate = mappedGroup.filter(
    ({ id }) => id !== KEEP_IT_FOR_ME_ANSWER_ID
  );

  if (groupWithoutPrivate.length === 0) {
    // If each answer of the group is 0 (KEEP_IT_FOR_ME)
    // So we return the first answer label (like: "je le garde pour moi")
    return [mappedGroup[0]['label']];
  }

  return groupWithoutPrivate.reduce<string[]>(
    (result, { id, label, modifier }) => {
      const answerLabel = modifier ? modifier({ id, label }) : label;

      if (answerLabel) result.push(answerLabel);

      return result;
    },
    []
  );
};

export const selectInformations = (
  memberAnswerLabels: TAnswersLabels,
  memberAnswers: TAnswers
) => ({
  familyStatus: mapAnswersGroup(memberAnswers, [
    { label: EMemberChoicesLabels.profileMaritalStatus },
    {
      label: EMemberChoicesLabels.childNumber,
      modifier: ({ id }: IAnswer) => id.toString(),
    },
  ]),
  hair: mapAnswersGroup(memberAnswers, [
    { label: EMemberChoicesLabels.profileHairStyle },
    { label: EMemberChoicesLabels.profileHairColor },
  ]),
  bodyShapeHeightWeight: mapAnswersGroup(memberAnswers, [
    { label: EMemberChoicesLabels.profileBodyShape },
    { label: EMemberChoicesLabels.profileHeight },
    { label: EMemberChoicesLabels.profileWeight },
  ]),
  eyes: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.profileEyes
  ),
  smoker: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.profileSmokeHabit
  ),
  alcohol: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.alcoholHabit
  ),
  // See more
  studies: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.profileStudies
  ),
  income: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.profileIncome
  ),
  childrenWish: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.profileChildrenWish
  ),
  pet: getAnswerFromLabel(memberAnswerLabels, EMemberChoicesLabels.profilePet),
  cooking: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.profileFoodHabit
  ),
  origin: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.profileEthnicity
  ),
  nationality: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.profileNationality
  ),
  religion: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.profileReligion
  ),
  religionBehaviour: getAnswerFromLabel(
    memberAnswerLabels,
    EMemberChoicesLabels.profileReligionBehaviour
  ),
});

export type IInformation = ReturnType<typeof selectInformations>;
